import { useMemo } from 'react';
import { ActivityCategory, RelatedToEnum } from 'ui/types/activities';

import { useAppSelector } from '~/hooks/useAppSelector';
import { useQuery } from '~/hooks/useQuery';
import { IPaginatedResponse } from '~/types';

const getEcosystemFilter = (
  relatedTo: RelatedToEnum,
  ecosystemCauses?: string[],
) => {
  if (relatedTo !== 'causeOptions') return {};

  return {
    _id: { $in: ecosystemCauses || [] },
  };
};

export const useActivityCategories = (relatedTo: RelatedToEnum) => {
  const { selectedEcosystem } = useAppSelector(({ ecosystem }) => ecosystem);
  const ecosystemKey = useMemo(
    () => JSON.stringify(selectedEcosystem?.causeOptions || []),
    [selectedEcosystem],
  );

  const { data, isLoading, refetch } = useQuery<
    IPaginatedResponse<ActivityCategory[]>
  >(`/activity-category`, {
    key: `activity-categories-${relatedTo}-${ecosystemKey}`,
    requestOptions: {
      params: {
        filter: JSON.stringify({
          relatedTo,
          ...getEcosystemFilter(relatedTo, selectedEcosystem?.causeOptions),
        }),
        limit: 1000,
      },
    },
  });

  const uniqueData: Set<string> = new Set();
  const uniqueDataArray: ActivityCategory[] = [];

  data?.data?.forEach((current) => {
    if (current.displayName && !uniqueData.has(current.displayName)) {
      uniqueData.add(current.displayName);
      uniqueDataArray.push(current);
    }
  });

  return { data: uniqueDataArray, isLoading, refetch };
};
